module.exports = __webpack_public_path__ + "static/media/baner.c60284b5.jpg";